module.exports = __webpack_public_path__ + "static/img/datikuang-0.6eca4b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/datikuang-0.png
// module id = m1M6
// module chunks = 0